import { fetcher } from "utils";

export const delete__users__stores = (storeId: number | string): Promise<" "> =>
  fetcher.delete(`/users/stores/${storeId}`);
